// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"DroppableDiv_mainContainer__2WuyZ","dragover":"DroppableDiv_dragover__3ss2V","illegalDrag":"DroppableDiv_illegalDrag__2mc0Y"};